import canSeeUserShifts from './canSeeUserShifts';
import context from '../context';
import { LEAVE_TYPE } from '../constants';

export default function setContext(contextProps) {
  const { orgUsers, orgLocations, orgPositions, timeOffTypes, orgGroups = [] } = contextProps;
  const personasDict = Object.create(null);
  [...orgUsers, ...orgLocations, ...orgPositions, ...orgGroups].forEach((persona) => {
    personasDict[persona.id] = persona;
  });

  Object.assign(context, {
    personasDict,
    getTimeOffTypes: () => timeOffTypes,
    canSeeUser: (user) => !user.id || canSeeUserShifts(user),
    isTimeOff: (eventType) => eventType === LEAVE_TYPE,
    ...contextProps,
  });
}
